import { render } from "./AutoReadingItem.vue?vue&type=template&id=8cf3eff2&scoped=true"
import script from "./AutoReadingItem.vue?vue&type=script&lang=js"
export * from "./AutoReadingItem.vue?vue&type=script&lang=js"

import "./AutoReadingItem.vue?vue&type=style&index=0&id=8cf3eff2&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cf3eff2"]])

export default __exports__